import { TEXT_KEY, getText } from '../../../utils/localization';
import { REWARD_CENTER_COST_TYPE, REWARD_CENTER_OFFERS_STATUS } from '../constants';
export var hasSoldOutState = function hasSoldOutState(ribbontype) {
  return ribbontype === REWARD_CENTER_OFFERS_STATUS.SOLD_OUT;
};
export var hasLimitedState = function hasLimitedState(ribbontype) {
  return ribbontype === REWARD_CENTER_OFFERS_STATUS.LIMITED;
};
var isValidNumber = function isValidNumber(num) {
  return Number(num) && Number(num) > 0;
};
var hasValue = function hasValue(value) {
  return value !== undefined && value !== null && value !== '';
};
var getFirstDefinedValue = function getFirstDefinedValue() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }
  return values.find(hasValue);
};
var parseNumericValue = function parseNumericValue(value) {
  if (!hasValue(value)) return null;
  var normalizedValue = typeof value === 'string' ? value.replace(/,/g, '').trim() : value;
  var numericValue = Number(normalizedValue);
  return Number.isFinite(numericValue) ? numericValue : null;
};
var hasPositiveNumericValue = function hasPositiveNumericValue(value) {
  var numericValue = parseNumericValue(value);
  return Number.isFinite(numericValue) && numericValue > 0;
};
var normalizeStringValue = function normalizeStringValue(value) {
  return "".concat(value || '').trim().toLowerCase();
};
var isVipRoomAccessRewardType = function isVipRoomAccessRewardType(rewardType) {
  return normalizeStringValue(rewardType) === 'vip_room_access';
};
var calculateMinRedeems = function calculateMinRedeems(maxperplayer, maxredemption) {
  var isMaxPerPlayerValid = isValidNumber(maxperplayer);
  var isMaxRedemptionValid = isValidNumber(maxredemption);
  if (!isMaxPerPlayerValid && !isMaxRedemptionValid) return 0;
  if (isMaxPerPlayerValid && isMaxRedemptionValid) return Math.min(Number(maxperplayer), Number(maxredemption));
  if (isMaxPerPlayerValid) return Number(maxperplayer);
  return Number(maxredemption);
};

// BE sends `coins` for init rewards and `coinsneeded` for reward details.
// Adapter forwards both as `coinsRequired`.
export var getOfferCoinsRequired = function getOfferCoinsRequired(offer) {
  return parseNumericValue(getFirstDefinedValue(offer === null || offer === void 0 ? void 0 : offer.coins, offer === null || offer === void 0 ? void 0 : offer.coinsRequired, offer === null || offer === void 0 ? void 0 : offer.coinsneeded));
};

// BE sends `loyalty` / `lpts` for init rewards and `pointsneeded` for reward details.
// Adapter forwards all of them as `loyaltyPoints`.
export var getOfferLoyaltyPoints = function getOfferLoyaltyPoints(offer) {
  return parseNumericValue(getFirstDefinedValue(offer === null || offer === void 0 ? void 0 : offer.loyalty, offer === null || offer === void 0 ? void 0 : offer.loyaltyPoints, offer === null || offer === void 0 ? void 0 : offer.pointsneeded, offer === null || offer === void 0 ? void 0 : offer.lpts));
};

// Accepts both raw BE offers (`redeemcurrency`, `coinsneeded`, `pointsneeded`) and already-adapted offers (`costType`).
export var getOfferCostType = function getOfferCostType(offer) {
  if ((offer === null || offer === void 0 ? void 0 : offer.costType) === REWARD_CENTER_COST_TYPE.COINS) return REWARD_CENTER_COST_TYPE.COINS;
  if ((offer === null || offer === void 0 ? void 0 : offer.costType) === REWARD_CENTER_COST_TYPE.LOYALTY) return REWARD_CENTER_COST_TYPE.LOYALTY;
  var redeemCurrency = normalizeStringValue(offer === null || offer === void 0 ? void 0 : offer.redeemcurrency);
  if (redeemCurrency === REWARD_CENTER_COST_TYPE.COINS) return REWARD_CENTER_COST_TYPE.COINS;
  if (redeemCurrency === REWARD_CENTER_COST_TYPE.LOYALTY) return REWARD_CENTER_COST_TYPE.LOYALTY;
  if (hasPositiveNumericValue(getFirstDefinedValue(offer === null || offer === void 0 ? void 0 : offer.coins, offer === null || offer === void 0 ? void 0 : offer.coinsRequired, offer === null || offer === void 0 ? void 0 : offer.coinsneeded))) {
    return REWARD_CENTER_COST_TYPE.COINS;
  }
  if (hasPositiveNumericValue(getFirstDefinedValue(offer === null || offer === void 0 ? void 0 : offer.loyalty, offer === null || offer === void 0 ? void 0 : offer.loyaltyPoints, offer === null || offer === void 0 ? void 0 : offer.pointsneeded, offer === null || offer === void 0 ? void 0 : offer.lpts))) {
    return REWARD_CENTER_COST_TYPE.LOYALTY;
  }
  return REWARD_CENTER_COST_TYPE.LOYALTY;
};
export var isCoinOffer = function isCoinOffer(offer) {
  return getOfferCostType(offer) === REWARD_CENTER_COST_TYPE.COINS;
};
export var getOfferPriceValue = function getOfferPriceValue(offer) {
  var _getOfferCoinsRequire, _getOfferLoyaltyPoint;
  return isCoinOffer(offer) ? (_getOfferCoinsRequire = getOfferCoinsRequired(offer)) !== null && _getOfferCoinsRequire !== void 0 ? _getOfferCoinsRequire : 0 : (_getOfferLoyaltyPoint = getOfferLoyaltyPoints(offer)) !== null && _getOfferLoyaltyPoint !== void 0 ? _getOfferLoyaltyPoint : 0;
};

// Format an offer price for display. Keeps full thousands separators below 1B,
// switches to compact suffixes (B/T/Q) above so 12+ digit values fit inside the card.
export var formatOfferAmount = function formatOfferAmount(value) {
  var n = parseNumericValue(value);
  if (n === null || n === 0) return '0';
  if (Math.abs(n) < 1e9) {
    return Math.trunc(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  var units = [{
    v: 1e15,
    s: 'Q'
  }, {
    v: 1e12,
    s: 'T'
  }, {
    v: 1e9,
    s: 'B'
  }];
  for (var _i = 0, _units = units; _i < _units.length; _i++) {
    var _units$_i = _units[_i],
      v = _units$_i.v,
      s = _units$_i.s;
    if (Math.abs(n) >= v) {
      var scaled = n / v;
      var abs = Math.abs(scaled);
      var decimals = abs < 10 ? 2 : abs < 100 ? 1 : 0;
      return "".concat(scaled.toFixed(decimals)).concat(s);
    }
  }
  return Math.trunc(n).toString();
};

// MVP: BE may not send `benefit_description` yet. Hardcoded fallback only for VIP Room Access.
// TODO post-MVP: require BE to always send `benefit_description` (XP boosts, bundles, etc.).
export var getOfferBenefitDescription = function getOfferBenefitDescription(offer) {
  var _offer$rewardType;
  return getFirstDefinedValue(offer === null || offer === void 0 ? void 0 : offer.benefitDescription, offer === null || offer === void 0 ? void 0 : offer.benefit_description, isCoinOffer(offer) && isVipRoomAccessRewardType((_offer$rewardType = offer === null || offer === void 0 ? void 0 : offer.rewardType) !== null && _offer$rewardType !== void 0 ? _offer$rewardType : offer === null || offer === void 0 ? void 0 : offer.rewardtype) ? getText(TEXT_KEY.REWARD_CENTER_HIGH_LIMIT_ROOM_ACCESS) : null);
};

// Returns ` {remainingredeems}/{minRedeems}` when the offer is in a limited state and
// the remaining redemptions are at or below the per-player/global cap. Empty string otherwise.
export var getRemainingRedeemsSuffix = function getRemainingRedeemsSuffix(offer) {
  var ribbontype = offer.ribbontype,
    remainingredeems = offer.remainingredeems,
    maxperplayer = offer.maxperplayer,
    maxredemption = offer.maxredemption;
  var minRedeems = calculateMinRedeems(maxperplayer, maxredemption);
  if (hasLimitedState(ribbontype) && isValidNumber(remainingredeems) && isValidNumber(minRedeems) && remainingredeems <= minRedeems) {
    return " ".concat(remainingredeems, "/").concat(minRedeems);
  }
  return '';
};
export var getOfferDescription = function getOfferDescription(offer) {
  return "".concat(offer.rewardName).concat(getRemainingRedeemsSuffix(offer));
};
export var getOfferCardDescription = function getOfferCardDescription(offer) {
  return isCoinOffer(offer) ? getFirstDefinedValue(offer === null || offer === void 0 ? void 0 : offer.rewardName, offer === null || offer === void 0 ? void 0 : offer.rewardname, getOfferBenefitDescription(offer), '') : getOfferDescription(offer);
};
export var getOfferCardTitle = function getOfferCardTitle(offer) {
  return isCoinOffer(offer) ? "".concat(getOfferCardDescription(offer)).concat(getRemainingRedeemsSuffix(offer)) : getOfferCardDescription(offer);
};
export var hasSufficientOfferBalance = function hasSufficientOfferBalance(offer) {
  var balances = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var priceValue = getOfferPriceValue(offer);
  if (!Number.isFinite(priceValue)) return true;
  var balanceValue = isCoinOffer(offer) ? parseNumericValue(balances.coinBalance) : parseNumericValue(balances.loyaltyBalance);
  if (!Number.isFinite(balanceValue)) return true;
  return balanceValue >= priceValue;
};
export var getOfferInsufficientBalanceMessage = function getOfferInsufficientBalanceMessage(offer) {
  if (isCoinOffer(offer)) return getText(TEXT_KEY.REWARD_CENTER_INSUFFICIENT_COINS_TITLE);
  return getText(TEXT_KEY.REWARD_CENTER_INSUFFICIENT_FUNDS_TITLE);
};